export const FEEDBACK_TYPE = {
    PRODUCT: "product",
    SUMMARY: "summary"
}

export const FEEDBACK_MODAL_HEADER = {
    PRODUCT: "How was your experience with Amazon Meetings Summary?",
}

export const FEEDBACK = {
    THUMBS_UP: "ThumbsUp",
    THUMBS_DOWN: "ThumbsDown"
};

export const FEEDBACK_MESSAGES = {
    SUBMITTED: "Thank you. All feedback is a gift",
    NOT_SUBMITTED: "No feedback has been provided"
};

export const FEEDBACK_REASONS = {
    NOT_ACCURATE: "Summary isn't accurate",
    NOT_COMPLETE: "Summary isn't complete",
    BLOCKED: "Summary shouldn't be blocked"
};

export const FEEDBACK_MODAL_STAGE = {
    RATING: "rating",
    COMMENT: "comment",
    SUBMITTED: "submitted",
}
// Theme token overrides
export const FEEDBACK_THEME_TOKENS = {
    buttonForegroundColorTertiaryDefault: "#575f67",
    buttonBorderColorTertiaryDefault: "#575f67", 

    buttonBorderColorTertiaryHover: "#575f67",
    buttonBackgroundColorTertiaryHover: "#575f67", 
    buttonBorderColorTertiaryPressed: "#575f67",
    buttonBackgroundColorTertiaryPressed: "#575f67",


    buttonForegroundColorPrimaryDisabled: "#575f67",
    buttonBackgroundColorPrimaryDisabled: "#d7dce2",
    buttonForegroundColorTertiaryDisabled: "#d7dce2",
    buttonBorderColorTertiaryDisabled: "#d7dce2",
};
